// extracted by mini-css-extract-plugin
export default {"loadingLabel":"ExternalPlaylistLoader_loadingLabel__gnA+2","spinnerLabel":"ExternalPlaylistLoader_spinnerLabel__dbRfp"};